import EventBus from './Event/index.js';
import { oreqGetFields, oreqSaveFields } from './api_client/api_offer_request.js';
import Modal from './Modal.js';
import { validators } from './utils/utils-form.js';

class OfferRequestForm {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$inputs = this.$el.find('input, select, textarea');
    this.$actionSaveStep = this.$el.find('[data-form-action="save"]');
    this.$actionNextStep = this.$el.find('[data-form-action="next"]');
    this.$actionNextSubmit = this.$el.find('[data-form-action="submit"]');
    
    this.formStep = 1;
    this.offerRequest = {};
    
    this.inputsState = {};
    this.initInputsState();
    console.log('init offer request form');

    this.isAgent = window.location.pathname === '/dashboard-agent-home';
    if (this.isAgent) {
      this.$actionNextSubmit.remove();
      this.$el.find('[data-form-step="4"]').remove();
      $(document.body).find('[data-progress-step="4"]').prev('.progress_step_line').remove();
      $(document.body).find('[data-progress-step="4"]').remove();
    }

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  // set initial state of inputs
  initInputsState() {
    this.inputsState.oreq_id = this.inputsState.oreq_id || (new Date()).getTime();
    console.log('initInputsState: ', this.inputsState.oreq_id);
    this.$inputs.each((i, input) => {
      const $input = $(input);
      const name = $input.attr('name');
      if ($input.attr('type') === 'checkbox') {
        this.inputsState[name] = $input.prop('checked') ? 'yes' : 'no';
      } else if ($input.attr('type') === 'radio') {
        this.inputsState[name] = $input.prop('checked') ? $input.val() : (this.inputsState[name] || '');
      } else if ($input.attr('name') === 'oreq_id') {
        this.inputsState[name] = this.inputsState.oreq_id || (new Date()).getTime();
        $input.val(this.inputsState.oreq_id);
      } else {
        this.inputsState[name] = $input.val();
      }
    });

    this.initConditionedFields();
  }

  initConditionedFields() {
    // show/hide groups of fields based on user input
    const $conditionedGroups = this.$el.find('[data-conditioned-group]');
    $conditionedGroups.each((i, group) => {
      const $group = $(group);
      const $conditionField = this.$el.find(`[name=${$group.data('conditioned-by')}]`);
      const $conditionedRequiredFields = this.$el.find(`[name=${$group.data('conditioned-required')}]`);
  
      if (!$conditionField.length) {
        return;
      }
  
      const value = this.inputsState[$conditionField.attr('name')];
      const valuesToShow = {
        'oreq_new_paint': value == 'yes' || value == 'true',
        'oreq_carpet': value == 'yes' || value == 'true',
        'oreq_replace_others': $conditionField.prop('checked'),
      }

      if ($conditionField.attr('name') === 'oreq_new_paint') {
        console.log({ $group, value, condition: valuesToShow['oreq_new_paint'] });
      }
      
      if (valuesToShow[$conditionField.attr('name')]) {
        $group.show();
        $conditionedRequiredFields.attr('required', true);
      } else {
        $group.hide();
        $conditionedRequiredFields.removeAttr('required');
      }
  
      $conditionField.on('change', (e) => {
        const $input = $(e.target);
        const value = $input.val();
        const valuesToShow = {
          'oreq_new_paint': value == 'yes' || value == 'true',
          'oreq_carpet': value == 'yes' || value == 'true',
          'oreq_replace_others': $conditionField.prop('checked'),
        }
        if (valuesToShow[$conditionField.attr('name')]) {
          $group.show();
          $conditionedRequiredFields.attr('required', true);
        } else {
          $group.hide();
          $conditionedRequiredFields.removeAttr('required');
          if ($conditionField.attr('name') === 'oreq_replace_others') {
            $group.siblings('.form_error_message').remove();
          }
        }
      });
    });
  }

  // clear all inputs
  clearInputs() {
    console.log('clearInputs');
    this.$inputs.each((i, input) => {
      const $input = $(input);
      if ($input.attr('name') === 'oreq_owner_user') {
        return;
      }

      if ($input.attr('type') === 'checkbox') {
        $input.prop('checked', false);
      } else if ($input.attr('type') === 'radio') {
        $input.prop('checked', false);
      } else if ($input.attr('name') === 'oreq_id') {
        this.inputsState.oreq_id = (new Date()).getTime();
        $input.val(this.inputsState.oreq_id);
      } else {
        $input.val('');
      }
    });
    this.initInputsState();
    // this.initSignatureFields();

    EventBus.emit('form-steps:navigate', { step: 1 });
  }

  // update inputs state
  updateInputsState(fieldName, value) {
    this.inputsState[fieldName] = value;
    const $input = this.$inputs.filter(`[name="${fieldName}"]`);

    if ($input.attr('type') === 'radio') {
      $input.filter(`[value="${value}"]`).prop('checked', true);
    } else if ($input.attr('type') === 'checkbox') {
      const shouldBeChecked = value === 'yes' || value === 'true';
      $input.prop('checked', shouldBeChecked);
      $input.val(shouldBeChecked ? 'yes' : 'no');
    } else {
      $input.val(value);
    }
  }

  bindEvents() {
    this.$inputs.on('change', this.onInputChange.bind(this));
    this.$actionSaveStep.on('click', this.onSaveUserFields.bind(this));
    this.$el.on('submit', this.onFormSubmit.bind(this));

    EventBus.on('user:loaded', this.getUserOreqFields.bind(this));
    EventBus.on('user:empty', this.onUserEmpty.bind(this));

    EventBus.on('form-steps:navigate', this.onFormStepNavigate.bind(this));
    EventBus.on('form-steps:before-navigate', this.onBeforeNavigate.bind(this));

    EventBus.on('offer-request:continue', this.onContinueOfferRequest.bind(this));
    EventBus.on('offer-request:clear', this.clearInputs.bind(this));
    EventBus.on('offers-table:coapplicants-loaded', this.onCoapplicantsLoaded.bind(this));
  }

  onInputChange(e) {
    const $input = $(e.target);
    const name = $input.attr('name');
    let value;
    if ($input.attr('type') === 'checkbox') {
      value = $input.prop('checked') ? 'yes' : 'no';
    } else if ($input.attr('type') === 'radio') {
      value = $input.prop('checked') ? $input.val() : '';
    } else {
      value = $input.val();
    }

    this.updateInputsState(name, value);
  }

  async getUserOreqFields() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    const oreq_owner_user = window.grapp.user.auth.email;
    const oreq_id = this.offerRequest.oreq_id || 'null';
    console.log('this.offerRequest: ', this.offerRequest);
    this.updateInputsState('oreq_owner_user', oreq_owner_user);
    try {
      const userFieldsRes = await oreqGetFields(oreq_owner_user, oreq_id);
      if (userFieldsRes.fields) {
        const userFields = userFieldsRes.fields;
        this.$inputs.each((i, input) => {
          const $input = $(input);
          const name = $input.attr('name');
          if (userFields[name]) {
            this.updateInputsState(name, userFields[name]);
          }
        });
        this.updateInputsState('oreq_id', userFields[oreq_id]);
      }
    } catch(err) {
      console.log('err: ', err);
    }
  }

  async onSaveUserFields() {
    const errors = this.validateFields();
    if (errors.length > 0) {
      return;
    };
    console.log('this.inputsState.oreq_id: ', this.inputsState.oreq_id);

    try {
      this.inputsState.oreq_status = 'draft';
      const saveRequest = await oreqSaveFields(this.inputsState);
      if (saveRequest) {
        EventBus.emit('offer-request:fields-saved', saveRequest);
        EventBus.emit('toast', {type: 'success', message: 'Saved!'});
        console.log('user fields saved successfully', saveRequest);
      } else {
        throw new Error('Save failed');
      }
    } catch(err) {
      EventBus.emit('toast', {type: 'error', message: 'Save failed. Please try again.'});
      console.log('Error saving user oreq fields: ', err);
    }
  }

  onFormStepNavigate(payload) {
    if (payload.step == 4 && this.isAgent) {
      return;
    }
    
    this.formStep = payload.step;

    if (this.isAgent) {
      this.$actionNextStep.toggle(payload.step < 3);
    }
  }

  onBeforeNavigate() {
    const errors = this.validateFields();
    EventBus.emit('form-steps:validation', errors.length === 0);
  }

  getValidationErrors() {
    const fieldsToValidate = {
      '1': [
        { name: 'oreq_property_address', validators: [validators.required] },
        { name: 'oreq_mls', validators: [validators.required, validators.number] },
      ],

      '2': [
        { name: 'oreq_agree_upgrade_policies', validators: [validators.checkbox] },
        { name: 'oreq_new_paint', validators: [validators.radio] },
        { name: 'oreq_carpet', validators: [validators.radio] },
        { 
          name: 'oreq_replace_others_description',
          validators: this.$inputs.filter('[name="oreq_replace_others_description"]').prop('required') 
            ? [validators.required] 
            : [],
        },
      ],

      '3': [],

      '4': [
        { name: 'oreq_all_residents_prequalified', validators: [validators.checkbox] },
        { name: 'oreq_all_residents_viewed_property', validators: [validators.checkbox] },
        { name: 'oreq_read_guidelines', validators: [validators.checkbox] },
        { name: 'oreq_agree_no_purchase', validators: [validators.checkbox] },
        { name: 'oreq_agree_no_purchase', validators: [validators.checkbox] },
        { name: 'oreq_responsible_for_costs', validators: [validators.checkbox] },
        { name: 'oreq_agree_delivery_responsibilities', validators: [validators.checkbox] },
        // { name: 'oreq_signature_name_1', validators: [validators.required] },
        // { name: 'oreq_signature_date_1', validators: [validators.required] },
      ],
    }

    const stepFields = fieldsToValidate[this.formStep];
    const errors = [];
    stepFields.forEach(field => {
      const $input = this.$inputs.filter(`[name="${field.name}"]`);
      const value = $input.val();
      field.validators.forEach(validator => {
        const validationArg = ($input.attr('type') === 'checkbox' || $input.attr('type') === 'radio') ? $input : value;
        if (!validator.validate(validationArg)) {
          errors.push({ name: field.name, message: validator.message });
        }
      });
    });

    return errors;
  }

  validateFields() {
    console.log('validateFields');
    let errors = this.getValidationErrors();

    if (errors.length) {
      errors.forEach(error => {
        const $field = this.$inputs.filter(`[name="${error.name}"]`);
        const isCheckbox = $field.attr('type') === 'checkbox';
        const isRadio = $field.attr('type') === 'radio';
        const isSelect = $field.is('select');
        let $parent;
        if (isCheckbox) { $parent = $field.parent().parent(); } 
        else if (isRadio) { $parent = $field.closest('.form_radio_group'); } 
        else if (isSelect) { $parent = $field.closest('.form_input_wrap'); }
        else { $parent = $field.parent(); }

        if ($field.hasClass('form_error_field')) {
          return;
        }
  
        $field.addClass('form_error_field');
        if ($parent.find(`[data-msg="${error.message}"]`).length === 0) {
          const $message = $(`<div class="form_error_message" data-msg="${error.message}">${error.message}</div>`);
          if (isCheckbox) { $parent.prepend($message); } 
          else if (isRadio || isSelect) { $parent.find('.form_field_label').after($message); }
          else { $field.before($message); }
        }
        // scroll to first error
        if (errors.indexOf(error) === 0) {
          const $modalMain = $('.modal.open .modal_main');
          const $modalInner = $modalMain.find('.modal_inner');
          const modalInnerOffset = $modalInner.offset().top;
          const fieldOffset = $field.offset().top;
          const offset = fieldOffset - modalInnerOffset;
          
          $modalMain.animate({
            scrollTop: offset - 100,
          }, 500);
        }
      });
    } else {
      this.$inputs.removeClass('form_error_field');
      this.$el.find('.form_error_message').remove();
      errors = [];
    }

    return errors;
  }

  onContinueOfferRequest(offerRequest) {
    this.offerRequest = offerRequest;
    console.log('continue: ', this.coapplicants);

    // this.initSignatureFields();
    
    // update inputsState
    this.$inputs.each((i, input) => {
      const $input = $(input);
      const name = $input.attr('name');
      if (offerRequest[name]) {
        this.updateInputsState(name, offerRequest[name]);
      }
    });
    this.updateInputsState('oreq_id', offerRequest.oreq_id);
    this.initConditionedFields();
  }

  initSignatureFields() {
    const $signatureFields = this.$el.find('[data-signature-fields]');
    if ($signatureFields.length === this.coapplicants?.length) {
      return;
    }
    // add signature fields for each coapplicant
    this.coapplicants.forEach((coapplicant, i) => {
      // if index is undefined, it's the current user
      if (coapplicant.index === undefined) { 
        return;
      }
      
      const $signatureFieldsClone = $signatureFields.clone();
      const $inputs = $signatureFieldsClone.find('input');
      const $nameField = $inputs.first();
      const $dateField = $inputs.last();

      $nameField
        .attr('name', `oreq_signature_name_${i + 1}`)
        .attr('data-name', `oreq_signature_name_${i + 1}`)
        .attr('id', `oreq_signature_name_${i + 1}`)
        // .attr('placeholder', `${coapplicant.first_name} ${coapplicant.last_name}`)
      $dateField
        .attr('name', `oreq_signature_date_${i + 1}`)
        .attr('data-name', `oreq_signature_date_${i + 1}`)
        .attr('id', `oreq_signature_date_${i + 1}`)
      
      $signatureFields.last().after($signatureFieldsClone);
    });

    // update collection of inputs with newly added coapplicant signature fields
    this.$inputs = this.$el.find('input, select, textarea');

    const currentSignatures = {};
    Object.keys(this.offerRequest)
      .filter(key => key.indexOf('oreq_signature_') === 0)
      .forEach(key => {
        currentSignatures[key] = this.offerRequest[key];
      });

    // update signature fields for each coapplicant
    this.$inputs.filter('[name^="oreq_signature_"]').each((i, input) => {
      const $input = $(input);
      const name = $input.attr('name');
      const value = currentSignatures[name] || '';

      $input.val(value);
      // enable fields for current user's signature
      if (value.indexOf(grapp.user?.customFields?.['first-name']) > -1) {
        $input.removeAttr('disabled');
        // $input.attr('required', true);
      } else {
        // $input.attr('disabled', true);
        $input.removeAttr('required');
      }

      if (Object.keys(currentSignatures).length === 0) {
        if (name !== 'oreq_signature_name_1') {
          $input.attr('disabled', true);
          $input.removeAttr('required');
        } else {
          $input.removeAttr('disabled');
          $input.attr('required', true);
        }
      }

      // change label to 'Full Name: Coapplicant [index]'
      const coappIndex = name.split('_').pop();
      $input.siblings('label').text(`Full Name: Coapplicant ${coappIndex}`);
    });

    this.$el.find('[data-signature-fields]')
      .find('input')
      .filter('[name^="oreq_signature_name_"]')
      .each((i, input) => {
        const $input = $(input);
        if (!$input.attr('disabled')) {
          $input.closest('[data-signature-fields]').find('[name^="oreq_signature_date_"]')
            .removeAttr('disabled')
            .attr('required', true);
        }
      });
  }

  onCoapplicantsLoaded(coapplicants) {
    this.coapplicants = coapplicants;
  }

  onFormSubmit(e) {
    // get form data from current form
    const formData = new FormData(this.el);
    let formSubmission = {};
    for (var [key, val] of formData.entries()) { 
      formSubmission[key] = val;
    }
    formSubmission.oreq_status = 'pending';
    formSubmission.oreq_id = this.inputsState.oreq_id;
    console.log('formSubmission: ', formSubmission);
    e.preventDefault();
    EventBus.emit('offer-request:submitted', { fields: formSubmission});

    Modal.close('offer-request');
  }

  // @TODO: implement handler for no user found
  onUserEmpty() {
    console.log('User is empty');
  }

  static init() {
    $('[data-js-form="offer-request"]').each((i, el) => new OfferRequestForm(el));
  }
}

OfferRequestForm.init();
